import { program } from "../mine";

program.parse(process.argv);
